import { BlankSlate } from "@msuite/ui/blank-slate";
import { ChartHeader } from "@msuite/ui/charts";
import { DashboardTile } from "@msuite/ui/dashboard";
import { useTranslation } from "@msuite/ui/localization";
import type { DashboardTileProps } from "../shared";

export function DashboardTodayItem({ item }: DashboardTileProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<DashboardTile item={item}>
			<ChartHeader title={t("dashboard.today")} />
			<BlankSlate />
		</DashboardTile>
	);
}
